import React from 'react';
import {ProgramFilter} from './ProgramFilter';
import {IWithDisabled} from 'models';

export function ProgramFilterMulti({disabled}: IWithDisabled) {
  return <ProgramFilter selectionType="multi" disabled={disabled} />;
}
